import {Scenario} from "../../../types";

export function circleInScenarios(scenarios: Scenario[]): string[] {
  const visited = new Set<string>();
  const circleNames: string[] = [];

  const checkForCircle = (scenarioId: string, path: string[] = []): boolean => {
    if (path.includes(scenarioId)) {
      const circleStart = path.indexOf(scenarioId);
      const circlePath = path.slice(circleStart);

      const namesInCircle = circlePath
        .map((id) => scenarios.find((s) => s.id === id)?.name)
        .filter((name): name is string => name !== undefined);

      circleNames.push(...namesInCircle);
      return true;
    }

    if (visited.has(scenarioId)) {
      return false;
    }

    visited.add(scenarioId);
    const scenario = scenarios.find((s) => s.id === scenarioId);

    if (!scenario) {
      return false;
    }

    if (!scenario.nextScenario) {
      return false;
    }

    return checkForCircle(scenario.nextScenario, [...path, scenarioId]);
  };

  scenarios.forEach((scenario) => {
    if (!visited.has(scenario.id) && scenario.nextScenario) {
      checkForCircle(scenario.id);
    }
  });

  return Array.from(new Set(circleNames));
}
